module.exports = __webpack_public_path__ + "img/sc-Seite29.4429e6a0.png";